import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Link,
  withRouter,
} from 'react-router-dom';

import { slugify } from '../../helpers';

const AdminBackUrl = ({ urls }) => (
  <div className="breadcrumbs">
    {urls.map(b => (
      <Fragment key={slugify(b.url)}>
        <Link to={b.url}>
          {b.label}
        </Link>
        <span>/</span>
      </Fragment>
    ))}
  </div>
);

AdminBackUrl.propTypes = {
  urls: PropTypes.array.isRequired,
};

export default withRouter(AdminBackUrl);
